module.exports = __webpack_public_path__ + "img/software_billing.c0fef432.jpg";